import React from 'react';
import { Icon, SecondaryTextXs } from 'atoms';
import { prioritySettings, colorShade } from 'utils';
import { IconLabel, TextButton } from 'molecules';
import { ContainerComponent, wrap } from 'AppReact';
import { DownCaretSvg, GreenTickSvg } from 'components/icons';
import {
  ScrollableDropdownRoundedCornersWrapper, Mr2, FilterHeaderWrapper,
  RelativeWrapper, FullWidthRowCenterScrollWrapper, My2, CustomBorderWrapper,
  FlexCenterBetweenWrapper, Px3, Mt4, Mb2
} from 'wrappers';
import internalState from './internalState';
import controller from './controller';

const containerRef = React.createRef();

export const definition = {
  name: 'MultiPrioritySelector',
  controller,
  initialProps: ({ priorities, selectedPriorities }) => ({ priorities, selectedPriorities }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: '__transparent__',
      ref: containerRef,
      elements: [
        {
          wrapper: FilterHeaderWrapper,
          name: 'Selector',
          isButton: true,
          bindings: ({ isOpen }) => ({ isOpen, containerRef }),
          elements: [
            {
              wrapper: FullWidthRowCenterScrollWrapper,
              name: 'PriorityWrapper',
              elements: [
                {
                  component: wrap(IconLabel, Mr2),
                  isListOf: 'selectedPriorities',
                  name: 'Selector',
                  bindings: ({ isOpen, priorities, selectedPriority }) => {
                    let priority = priorities.find(priority => priority.id === selectedPriority);
                    return { isOpen, containerRef, text: priority?.name, icon: prioritySettings.icon(priority), selectedPriority }
                  },
                  displayState: ({ priorities, selectedPriority }) => {
                    let priority = priorities.find(priority => priority.id === selectedPriority);
                    return { background: prioritySettings[priority?.color]?.background ?? '#F4FCF8', color: prioritySettings[priority?.color]?.textColor ?? '#1DBD6B', clickable: true }
                  },
                }
              ]
            },
            {
              component: Icon,
              name: 'DownCaret',
              displayValue: () => DownCaretSvg({}),
              bindings: ({ }) => ({})
            },
          ]
        },
        {
          wrapper: ScrollableDropdownRoundedCornersWrapper,
          name: 'Body',
          renderIf: ({ isOpen }) => isOpen,
          displayState: ({ }) => ({ minWidth: '100%' }),
          elements: [
            {
              wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Px3), Mt4), Mb2),
              name: 'ClearAllHeader',
              renderIf: ({ isOpen }) => isOpen,
              elements: [
                {
                  component: SecondaryTextXs,
                  name: 'SelectedText',
                  displayValue: ({ selectedPriorities }) => `${(selectedPriorities.length ?? 0)} Selected`
                },
                {
                  component: TextButton,
                  name: 'ClearAll',
                  bindings: ({ selectedPriorities, priorities }) => ({ mobileSmall: true, small: true, selectedPriorities, priorities, title: (selectedPriorities.length ?? 0) > 0 ? 'Clear all' : 'Select all' }),
                }
              ]
            },
            {
              wrapper: My2,
              name: '__transparent__',
              isListOf: 'priorities',
              elements: [
                {
                  wrapper: CustomBorderWrapper,
                  name: 'Option',
                  isButton: true,
                  displayState: ({ selectedPriorities, priority }) => ({
                    background: selectedPriorities?.includes(priority.id) ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : '',
                    padding: '4px 8px',
                    hoverBackground: colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')
                  }),
                  bindings: ({ priority, selectedPriorities }) => ({ selectedPriorities, priority }),
                  elements: [
                    {
                      wrapper: FlexCenterBetweenWrapper,
                      name: '__transparent__',
                      elements: [
                        {
                          component: IconLabel,
                          name: 'Option',
                          bindings: ({ priority, selectedPriorities }) => ({ selectedPriorities, priority, text: priority.name, icon: prioritySettings.icon(priority) }),
                          displayState: ({ priority }) => ({ background: prioritySettings[priority.color]?.background ?? '#F4FCF8', color: prioritySettings[priority?.color]?.textColor ?? '#1DBD6B', clickable: true })
                        },
                        {
                          component: Icon,
                          renderIf: ({ priority, selectedPriorities }) => selectedPriorities?.includes(priority.id),
                          name: 'Checkbox',
                          displayValue: ({ }) => GreenTickSvg({})
                        }
                      ]
                    }
                  ]
                },
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition)
